<template>
  <div class="standard-page v-flex">
    <div class="page-contents">
      <h2>Upload Accounts</h2>
      <b-button size="sm" variant="secondary">Upload CSV</b-button>

      <LineBreak> OR </LineBreak>

      <b-form @submit.prevent="createAccount" class="view-form">
        <div class="fields">
          <b-form-group
            v-if="show_merchant"
            label="Merchant Account ID"
            label-for="merchant_account"
            class="h-form-group"
          >
            <div>
              <b-form-select
                v-model="merchant_account"
                :options="merchant_accounts"
              ></b-form-select>
            </div>
          </b-form-group>
          <div class="text-danger field-errors">
            <div
              v-if="$v.merchant_account.$error && !$v.merchant_account.required"
            >
              This field is required
            </div>
          </div>

          <b-form-group
            label="External Id"
            label-for="external_id"
            class="h-form-group"
          >
            <div>
              <b-form-input
                id="external_id"
                v-model.trim="$v.external_id.$model"
                :state="$v.external_id.state"
              />
            </div>
          </b-form-group>
          <div class="text-danger field-errors">
            <div v-if="$v.external_id.$error && !$v.external_id.required">
              This field is required
            </div>
          </div>

          <b-form-group
            label="Amount Due"
            label-for="amount_due"
            class="h-form-group"
          >
            <div>
              <b-form-input
                id="amount_due"
                v-model.number="$v.amount_due.$model"
                :state="$v.amount_due.state"
              />
            </div>
          </b-form-group>
          <div class="text-danger field-errors">
            <div v-if="$v.amount_due.$error && !$v.amount_due.required">
              This field is required
            </div>
          </div>

          <b-form-group
            label="Customers"
            label-for="customers"
            class="h-form-group"
          >
            <div>
              <b-form-select
                v-model="customer"
                :options="customers"
              ></b-form-select>
            </div>
          </b-form-group>
          <div class="text-danger field-errors">
            <div v-if="$v.customers.$error && !$v.customers.required">
              This field is required
            </div>
          </div>

          <b-form-group
            label="Due Date"
            label-for="due_date"
            class="h-form-group"
          >
            <div>
              <b-form-input
                id="due_date"
                v-model.trim="$v.due_date.$model"
                :state="$v.due_date.state"
              />
            </div>
          </b-form-group>
          <div class="text-danger field-errors">
            <div v-if="$v.due_date.$error && !$v.due_date.required">
              This field is required
            </div>
          </div>

          <b-form-group
            label="Minimum payment"
            label-for="minimum_payment"
            class="h-form-group"
          >
            <div>
              <b-form-input
                id="minimum_payment"
                v-model.number="$v.minimum_payment.$model"
                :state="$v.minimum_payment.state"
              />
            </div>
          </b-form-group>
          <div class="text-danger field-errors">
            <div
              v-if="$v.minimum_payment.$error && !$v.minimum_payment.required"
            >
              This field is required
            </div>
          </div>

          <b-form-group
            label="Maximum payment"
            label-for="maximum_payment"
            class="h-form-group"
          >
            <div>
              <b-form-input
                id="maximum_payment"
                v-model.number="$v.maximum_payment.$model"
                :state="$v.maximum_payment.state"
              />
            </div>
          </b-form-group>
          <div class="text-danger field-errors">
            <div
              v-if="$v.maximum_payment.$error && !$v.maximum_payment.required"
            >
              This field is required
            </div>
          </div>
        </div>

        <LineBreak />

        <div class="form-actions fields">
          <b-button @click="onCancel" size="sm" variant="outline-danger">
            Cancel
          </b-button>
          <b-button size="sm" type="submit"> Create Account </b-button>
        </div>
      </b-form>
    </div>
    <b-modal id="modal" hide-footer size="sm" centered title="Account Created">
      <b-container fluid class="text-center">
        <b-button-group vertical>
          <b-button @click="viewAccounts">VIEW ACCOUNT LIST</b-button>
          <b-button @click="createNextAccount">CREATE NEXT ACCOUNT</b-button>
        </b-button-group>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import LineBreak from '@/components/Elements/LineBreak/LineBreak.vue'
import validations from './account-create-validation.js'
import endpoints from '@/utils/endpoints.js'

export default {
  components: {
    LineBreak
  },
  data() {
    return {
      external_id: '',
      amount_due: '',
      customer: null,
      customers: [],
      merchant_account: '',
      merchant_accounts: [],
      show_merchant: true,
      due_date: '',
      minimum_payment: '',
      maximum_payment: ''
    }
  },
  validations,
  mounted() {
    this.getMerchantAccounts()
    this.getCustomers()
  },
  methods: {
    viewAccounts() {
      this.$router.push({ name: 'AccountList' })
    },
    createNextAccount(event) {
      this.$bvModal.hide('modal')
    },
    onCancel() {
      this.$router.push({ name: 'AccountList' })
    },
    createAccount(event) {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const payload = {
          external_id: this.external_id,
          amount_due: this.amount_due,
          customers: [this.customer],
          merchant_account: this.merchant_account,
          due_date: this.due_date,
          minimum_payment: this.minimum_payment,
          maximum_payment: this.maximum_payment
        }

        this.axios
          .post(endpoints.createAccount(this.$route.params.merchantID), payload)
          .then(res => {
            event.target.reset()
            this.$bvModal.show('modal')
          })
          .catch(err => {
            if (err.response) {
              console.log('AXIOS ERROR', err)
            } else {
              console.log('JS ERROR')
            }
          })
      }
    },

    getMerchantAccounts() {
      this.axios
        .get(endpoints.listMerchantAccounts(this.$route.params.merchantID), {
          params: { page: 1, page_size: 10000 }
        })
        .then(res => {
          const accounts = res.data.results
          if (accounts.length === 1) {
            this.merchant_account = accounts[0].id
            this.show_merchant = false
          } else {
            let results = [{ value: null, text: 'Select a Merchant Account' }]
            for (const account of accounts) {
              results.push({ value: account.id, text: account.location_name })
            }
            this.merchant_accounts = results
            this.show_merchant = true
          }
        })
        .catch(err => {
          console.log('error', err)
        })
    },
    getCustomers() {
      this.axios
        .get(endpoints.listCustomers(this.$route.params.merchantID), {
          params: { page: 1, page_size: 10000 }
        })
        .then(res => {
          let results = [{ value: null, text: 'Select a Customer' }]
          for (const customer of res.data.results) {
            const name = customer.first_name + ' ' + customer.last_name
            results.push({ value: customer.id, text: name })
          }
          this.customers = results
        })
        .catch(err => {
          console.log('error', err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-group-vertical > button {
  margin-bottom: 10px;
  border-radius: 5px !important;
}
</style>
